
export default {
    defaultRoute: '/',
    defaultRoutes: {
        public: '/',
        appUser: '/user/dashboard',
        appAdmin: '/admin/dashboard',
        login: '/entry/login',
        entry: '/entry',
    },
    layers: {
        base: {
            template: `<div id="root-container-wrapper" class="vh-100"><div id="dev-tools-container"></div></div>`,
            components: [
                { name: 'entry-layer', type: 'layer', layer: 'entry', container: 'root-container-wrapper' },
                { name: 'app-layer', type: 'layer', layer: 'app', container: 'root-container-wrapper' },
                { name: 'error-layer', type: 'layer', layer: 'error', container: 'root-container-wrapper' },
                { name: 'privacy', type: 'layer', layer: 'privacy-policy', container: 'root-container-wrapper' },
                { name: 'terms', type: 'layer', layer: 'terms-of-service', container: 'root-container-wrapper' },
                { name: 'devtools', type: 'DevTools', container: 'dev-tools-container' },
                { name: 'payment-gateway', type: 'PaymentGatewayComponent', container: 'root-container-wrapper' },
            ]
        },
        entry: {
            route: '/entry',
            template: `
                <div class="entry-page-wrapper">
                    <div class="entry-panel card flex-row">
                        <div class="branding-pane"><div id="entry-branding-container"></div></div>
                        <div class="form-pane card-body"><div id="entry-form-target"></div></div>
                    </div>
                </div>
            `,
            components: [
                { name: 'entry-branding', type: 'EntryBranding', container: 'entry-branding-container', props: { logoText: "AppmageWebsite", iconClass: "bi bi-shield-lock-fill" } },
                { name: 'login-layer', type: 'layer', layer: 'login', container: 'entry-form-target', default: true },
                { name: 'signup-layer', type: 'layer', layer: 'signup', container: 'entry-form-target' },
                { name: 'forgotpassword-layer', type: 'layer', layer: 'forgotpassword', container: 'entry-form-target' }
            ]
        },

        login: { route: '/entry/login', template: `<div id="login-target"></div>`, components: [{ name: 'login-comp', type: 'Login', container: 'login-target' }] },
        signup: { route: '/entry/signup', template: `<div id="signup-target"></div>`, components: [{ name: 'signup-comp', type: 'Signup', container: 'signup-target' }] },
        forgotpassword: { route: '/entry/forgot-password', template: `<div id="forgot-target"></div>`, components: [{ name: 'forgot-comp', type: 'ForgotPassword', container: 'forgot-target' }] },

        app: {
            route: '/(user|admin)',
            template: `
                <div class="d-flex flex-column h-100">
                    <header id="main-header" class="app-header"></header>
                    <main id="main-content-area" class="d-flex flex-grow-1 overflow-hidden"></main>
                </div>
            `,
            components: [
                { name: 'shared-header-layer', type: 'layer', layer: 'shared-header', container: 'main-header' },
                { name: 'user-section-layer', type: 'layer', layer: 'user-section', container: 'main-content-area' },
                { name: 'admin-section-layer', type: 'layer', layer: 'admin-section', container: 'main-content-area' },
            ]
        },
        "shared-header": {
            template: `
                <nav class="navbar navbar-expand shadow-sm h-100">
                    <div class="container-fluid">
                        <div id="logo-container"></div>
                        <div class="ms-auto d-flex align-items-center gap-2">
                            <div id="role-switcher-container"></div>
                            <div id="language-selector-container"></div>
                            <div id="notifications-container"></div>
                            <div id="user-profile-menu-container"></div>
                        </div>
                    </div>
                </nav>
            `,
            components: [
                { name: 'logo', type: 'LogoComponent', container: 'logo-container', props: { logoText: "AppmageWebsite" } },
                { 
                    name: 'role-switcher', 
                    type: 'RoleSwitcher', 
                    container: 'role-switcher-container',
                    props: {
                        hideFor: ['appUser'],
                        roleIcons: {
                            appAdmin: 'bi-shield-lock-fill',
                            appUser: 'bi-person-fill'
                        },
                        switchableRoles: ['appUser', 'appAdmin']
                    }
                },
                { 
                    name: 'language-selector', 
                    type: 'LanguageSelector', 
                    container: 'language-selector-container',
                    props: {} // No special props needed for default behavior
                },
                { name: 'notifications', type: 'Notifications', container: 'notifications-container' },
                { name: 'user-menu', type: 'UserProfileMenu', container: 'user-profile-menu-container', props: { showThemeSelector: true, menuItems: [{ title: "My Profile", route: "/user/profile", icon: "bi-person-circle" }] } },
            ]
        },
        "user-section": {
            route: '/user',
            template: `
                <div class="d-flex flex-row h-100 w-100">
                    <aside id="user-sidebar" class="app-sidebar border-end"></aside>
                    <main id="user-content" class="flex-grow-1 overflow-auto p-1"></main>
                </div>
            `,
            components: [
                { name: 'user-menu', type: 'AppMenu', container: 'user-sidebar', props: { startingRoute: '/user/', fullHeight: true, collapsible: true, defaultCollapsed:true, saveState: true } },
                { name: 'user-content-router', type: 'layer', layer: 'user-content', container: 'user-content' },
            ]
        },
        "user-content": {
            template: `<div id="user-feature-area" class="h-100"></div>`,
            components: [
                
                
                
                
                
            ]
        },
        
        
        
        
        
        "admin-section": {
            route: '/admin',
            template: `
                <div class="d-flex h-100 w-100">
                    <nav id="admin-sidebar" class="app-sidebar"></nav>
                    <div id="admin-content" class="flex-grow-1 p-1 overflow-auto"></div>
                </div>
            `,
            components: [
                { name: 'admin-menu', type: 'AppMenu', container: 'admin-sidebar', props: { startingRoute: '/admin/', fullHeight: true, collapsible: true, defaultCollapsed:true, saveState: true } },
                { name: 'admin-content-router', type: 'layer', layer: 'admin-content', container: 'admin-content' },
            ]
        },
        "admin-content": {
            template: `<div id="admin-feature-area" class="h-100"></div>`,
            components: [
                
                
                
                
                
                
            ]
        },
        
        
        
        
        
        
    }
};